<template>
  <div>
    <ValidationProvider v-slot="{ errors, validate, valid }" ref="filefield" :rules="validation">
      <v-file-input
          ref="fileinput"
          :disabled="false"
          :accept="accept"
          :label="title"
          @change="handleFileChange"
          :clearable="false"
          :error-messages="errors"
          :hint="hint"
          :persistent-hint=true
          v-model="val"
      >
        <!--<template v-slot:selection="{ text }">
          File uploaded
        </template>-->
      </v-file-input>
    </ValidationProvider>
    <div>
      <!--<span class="group pr-2">
        <v-icon>mdi-paperclip</v-icon>
      </span>-->
      <v-chip
          v-for="file in filearray"
          :key="file.file_name"
          class="ma-2"
          close
          color="primary"
          @click:close="popoff(file)"
      >
        {{ file.nombre }}
      </v-chip>
      <!--{{ filearray.length }}-->
    </div>
  </div>
</template>

<script>
    import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
    import SimpleUploadService from "@/services/SimpleUploadService";

    setInteractionMode('eager')

    export default {
        name: 'Upload',
        data() {
            return {
                chip1: false,
                disabled: false,
                filearray: [],
                progress: 0,
                val: null
            }
        },
        inject: ['parentValidator'],
        props: {
            multiple: Boolean,
            files: Array,
            title: String,
            validation: Object,
            hint: String,
            accept: String
        },
        components: {
            ValidationProvider, ValidationObserver
        },
        methods: {
            async handleFileChange(e, progress, file) {
                const {valid} = await this.$refs.filefield.validate(e);
                if (valid) {
                    this.progress = 0
                    SimpleUploadService.upload(e, this.$store.state.jwt, this.$store.state.endpoints.simpleupload, (event) => {
                        this.progress = Math.round((100 * event.loaded) / event.total);
                    })
                        .then((response) => {
                            if(!response.data.error){
                                if (this.multiple == true) {
                                    this.filearray.push(response.data)
                                    this.$emit("file-update",this.filearray)
                                } else {
                                    this.filearray = [response.data]
                                    this.$emit("file-update",response.data)
                                }
                            }
                            else{
                                alert(!response.data.error)
                            }

                        })
                        .catch((e) => {
                            this.progress = 0;
                            console.error(e)
                        });
                }
            },
            popoff(file) {
                if (this.multiple == true) {
                    for (let i = this.filearray.length - 1; i >= 0; --i) {
                        if (this.filearray[i].file_name == file.file_name) {
                            this.filearray.splice(i, 1);
                        }
                    }
                    this.$emit("file-update",this.filearray)
                }
                else {
                    this.filearray = []
                    this.$emit("file-update",[])
                }
                console.log("popoff")
                if(this.filearray.length <= 0){
                    this.val = null
                }

            }
        },
        created() {
            this.$validator = this.parentValidator
        },
        watch: {
            files: function (newV, oldV) {
                if (typeof newV == 'object' && JSON.stringify(newV[0]) == '[]'){
                    this.filearray = []
                }
                else{
                     this.filearray = newV
                }

                if(this.filearray.length <= 0 && this.validation.required==true){
                    this.validation.required = true
                }
                else{
                    this.validation.required = false
                }
            }
        }
    }
</script>